export const AUTH_TIMEOUT_MS = 8 * 60 * 60 * 1000;
const AUTH_STARTED_AT_KEY = 'auth_started_at';

export function getToken() {
  return localStorage.getItem('token');
}

export function setToken(token) {
  if (token) {
    localStorage.setItem('token', token);
  }
}

export function setAuthStartedAt(timestamp = Date.now()) {
  localStorage.setItem(AUTH_STARTED_AT_KEY, String(timestamp));
}

export function getAuthStartedAt() {
  const value = Number(localStorage.getItem(AUTH_STARTED_AT_KEY));
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function getAuthAgeMs(now = Date.now()) {
  const startedAt = getAuthStartedAt();
  return startedAt ? now - startedAt : null;
}

export function isSessionExpired(now = Date.now()) {
  const age = getAuthAgeMs(now);
  return age === null || age >= AUTH_TIMEOUT_MS;
}

export function getUser() {
  const raw = localStorage.getItem('user');

  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setUser(user) {
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
}

export function setAuth(data) {
  if (data?.token) {
    setToken(data.token);
    setAuthStartedAt();
  }

  if (data?.user) {
    setUser(data.user);
  }
}

export function clearAuth() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem(AUTH_STARTED_AT_KEY);
}

export function logout() {
  clearAuth();
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;

  if (isSessionExpired()) {
    clearAuth();
    return false;
  }

  return true;
}

export function isAdmin() {
  const user = getUser();
  return user?.role === 'admin';
}

export function updateStoredUser(patch) {
  const current = getUser();

  if (!current) return null;

  const updated = {
    ...current,
    ...patch,
  };

  setUser(updated);
  return updated;
}